<template>
  <router-view />
</template>

<script>
export default {
  name: 'ReturnPackagesWrapper',
};
</script>
